import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slide from '@mui/material/Slide';
import * as dates from '@simplybenefits/sb-dates';
import loadingGif from '../../../assets/loading.gif';

import {
    Tiles,
    Loader,
    MessageCard,
    Text,
    PlanDesign,
    CommissionsForm,
    Pricing,
    AssignPlans,
    ClassesDivisions,
    Modal,
    MetaModal,
    MetaBlock,
    ContainerControlSite,
    Content
} from '@simplybenefits/sb-ui-library';

import Header from '../../../components/Header.js';

import {
    savePlanDesign,
    savePlanDesignBenefitInitData,
    savePlanDesignField,
    getPlanDesignRevisions,
    getSinglePlanDesignRevision,
    revertToPlanDesignRevision,
    saveModularBlueprint,
    saveModularBenefitInitData,
    saveModularField,
    submitCommissions,
    saveCommissions,
    getCommissions,
    addDivision,
    editDivision,
    editClass,
    addClass,
    submitModuleBlueprint,
    submitPlanDesigns,
    createPlanDesign,
    createPlanDesignFromUpload,
    clonePlanDesign,
    submitPricing,
    savePricingInput,
    savePricing,
    saveTelusDrugPlanID,
    editRevision,
    getPricingRevisions,
    getSinglePricingRevision,
    assignPlans,
    rejectPricing,
    getRevision,
    getAccount,
    completeRevisions, getSpecialityProductMetaConfigs
} from '../../../actions/accounts';

import { validateBankingDetails } from '../../../actions/advisors.js';

class Revision extends PureComponent {
    state = {
        selectedSection: null,
        showCompleteRevisionsDialog: false,
        showQuoteMetaModal: false,
        revisionProcessing: false
    };

    _transition = (props) => <Slide direction="up" {...props} />;

    async componentDidMount() {
        await this.props.dispatch(getAccount(this.props.match.params.accountID));
        await this.props.dispatch(getRevision(this.props.match.params.revisionID));

        this.setState({
            selectedSection: window.location.hash.replace('#', '')
        });
    }

    _selectSection = (section) => {
        if (section) {
            window.location.hash = section;
        } else {
            window.location.hash = '';
        }

        this.setState({
            selectedSection: section
        });
    };


    _buildBreadcrumbs = () => {
        if (!this.state.selectedSection) {
            return [
                {
                    title: 'Accounts',
                    link: `/accounts`
                },
                {
                    title: this.props.currentAccountMeta.company,
                    link: `/accounts/${ this.props.currentAccountMeta.accountID }`
                },
                {
                    title: 'Amendment',
                    link: `/accounts/${ this.props.currentAccountMeta.accountID }/amendments/${ this.props.revision.amendmentID }`
                }
            ];
        }

        return [
            {
                title: 'Accounts',
                link: `/accounts`
            },
            {
                title: this.props.currentAccountMeta.company,
                link: `/accounts/${ this.props.currentAccountMeta.accountID }`
            },
            {
                title: 'Amendment',
                link: `/accounts/${ this.props.currentAccountMeta.accountID }/amendments/${ this.props.revision.amendmentID }`
            },
            {
                title: 'Revision',
                onClick: () => this._selectSection(null)
            }
        ];
    };

    _getSubHeader = () => {
        if (this.state.selectedSection === 'revision-plan-pricing') {
            return 'Plan Pricing';
        } else if (this.state.selectedSection === 'revision-plan-design') {
            return 'Plan Designs';
        } else if (this.state.selectedSection === 'revision-commissions') {
            return 'Commissions';
        } else if (this.state.selectedSection === 'revision-account-history') {
            return 'Account History';
        } else if (this.state.selectedSection === 'revision-assign-plans') {
            return 'Assign Plans';
        } else if (this.state.selectedSection === 'revision-classes-divisions') {
            return 'Classes and Divisions';
        }

        return 'Revision';
    };

    _toggleCompleteRevisions = () => {
        this.setState({
            showCompleteRevisionsDialog: !this.state.showCompleteRevisionsDialog
        });
    };

    _toggleRevisionProcessing = () => {
        this.setState({
            revisionProcessing: !this.state.revisionProcessing
        });
    };

    _completeRevisions = async () => {
        this._toggleCompleteRevisions();
        this._toggleRevisionProcessing();

        const success = await this.props.dispatch(completeRevisions(this.props.currentAccountMeta.accountID, this.props.revision.revisionID));

        if (success) {
            this._toggleRevisionProcessing();

            setTimeout(() => {
                window.location.href = `/accounts/${ this.props.currentAccountMeta.accountID }`;
            }, 2000);
        } else {
            this._toggleRevisionProcessing();
            this._toggleCompleteRevisions();
        }
    };

    render() {
        const { currentAccountMeta } = this.props;

        if (!currentAccountMeta || !this.props.revision) {
            return <Loader />;
        }

        const styles = {
            gif: {
                maxWidth: '25%',
                marginRight: 40
            },
            modalRow: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        };

        const subHeader = this._getSubHeader();
        const breadcrumbs = this._buildBreadcrumbs();

        const tiles = [
            {
                title: 'Classes & Divisions',
                description: 'Manage the Classes and Divisions for the Quote.',
                step: 1,
                completed: Number(this.props.revision.meta.state) > 0,
                disabled: this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                onClick: () => this._selectSection('revision-classes-divisions'),
                testid: 'classes-divisions-tile'
            },
            {
                title: 'Plan Designs',
                description: 'Review the plan designs.',
                step: 2,
                completed: Number(this.props.revision.meta.state) > 0,
                disabled: this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                onClick: () => this._selectSection('revision-plan-design'),
                testid: 'revision-plan-design-tile'
            },
            {
                title: 'Commissions',
                description: 'View and set commissions for this account.',
                step: 3,
                disabled: Number(this.props.revision.meta.state) < 1 || this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                completed: Number(this.props.revision.meta.state) > 1,
                onClick: () => this._selectSection('revision-commissions'),
                testid: 'commissions'
            },
            {
                title: 'Plan Pricing',
                description: 'Review and set pricing.',
                step: 4,
                disabled: Number(this.props.revision.meta.state) < 2 || this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                completed: Number(this.props.revision.meta.state) > 2,
                onClick: () => this._selectSection('revision-plan-pricing'),
                testid: 'revision-plan-pricing-tile'
            },
            {
                title: 'Assign Plans',
                description: 'Assign the final plan design for each class.',
                step: 5,
                disabled: Number(this.props.revision.meta.state) < 3 || this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                completed: Number(this.props.revision.meta.state) > 3,
                onClick: () => this._selectSection('revision-assign-plans'),
                testid: 'revision-assign-plans'
            },
            {
                title: 'Complete Revisions',
                description: 'Complete the revisions process and set the amendment to complete.',
                step: 6,
                disabled: Number(this.props.revision.meta.state) < 4 || this.props.revision.meta.status.toUpperCase() === 'COMPLETE',
                completed: Number(this.props.revision.meta.state) > 4,
                onClick: () => this._toggleCompleteRevisions(),
                testid: 'complete-revisions-tile'
            }
        ];

        const accountID = currentAccountMeta.accountID;
        const revisionID = this.props.revision.revisionID;

        return (
            <ContainerControlSite>
                <Header
                    subHeader={subHeader}
                    breadcrumbs={breadcrumbs}
                    selectedTitle="accounts"
                />

                <Content>
                    <Text
                        align="right"
                        light
                        bold
                    >
                        { currentAccountMeta.company } ({ currentAccountMeta.groupNum })
                    </Text>

                    <Text
                        align="right"
                        light
                    >
                        Advisor: { currentAccountMeta.advisor }
                    </Text>

                    {
                        currentAccountMeta.effDate &&
                            <Text
                                align="right"
                                light
                            >
                                Effective Date: { dates.getStartOfDay(currentAccountMeta.effDate, 'll') }
                            </Text>
                    }

                    <Text
                        align="right"
                        light
                    >
                        Secondary Policy #: { currentAccountMeta.secondaryPolicyNumber || 'None' }
                    </Text>

                    {
                        !this.state.selectedSection &&
                            <React.Fragment>
                                <MessageCard
                                    title={ `Amendment Revisions ${ this.props.revision.meta.status }` }
                                    subtitle={
                                        this.props.revision.meta.status.toUpperCase() === 'COMPLETE' ?
                                            `Revisions for amendment: ${ this.props.revision.amendmentID } have already been completed, effective ${ dates.getUTC(this.props.revision.meta.effectiveDate, 'll') }.`
                                            :
                                            `The signing authority has approved and signed amendment ${ this.props.revision.amendmentID } effective ${ dates.getUTC(this.props.revision.meta.effectiveDate, 'll') }. Please make the necessary revisions for the amendment below.`
                                    }
                                />

                                <Tiles tiles={tiles} stepped={ true } />

                                <Text bold medium margin="20px 10px 15px 10px">
                                    Company Details
                                </Text>

                                <MetaBlock
                                    data={ this.props.revision }
                                    showModal={ () => {
                                        this.setState({ showQuoteMetaModal: true });
                                    }}
                                    disabled={ this.props.revision.meta.status.toUpperCase() === 'COMPLETE' }
                                />

                                {
                                    this.state.showQuoteMetaModal &&
                                        <MetaModal
                                            hideModal={ () => {
                                                this.setState({ showQuoteMetaModal: false });
                                            }}
                                            showModal={ this.state.showQuoteMetaModal }
                                            loading={this.props.loading}
                                            edit={ (...params) => this.props.dispatch(editRevision(revisionID, ...params)) }
                                            advisorMeta={{ privateLabelID: this.props.currentAccountMeta.privateLabelID }}
                                            isMasterSite={ true }
                                            isRevision={ true }
                                            isEdit={ true }
                                            data={ this.props.revision }
                                            whitelabel={{}}
                                        />
                                }
                            </React.Fragment>
                    }

                    {
                        this.state.selectedSection === 'revision-classes-divisions' &&
                            <ClassesDivisions
                                currentAccountMeta={ this.props.currentAccountMeta }
                                setState={ this.props.setState }
                                step={ this.props.revision.meta.state }
                                addDivision={ (...params) => this.props.dispatch(addDivision(...params, null, revisionID)) }
                                editDivision={ (...params) => this.props.dispatch(editDivision(...params, null, revisionID)) }
                                editClass={ (...params) => this.props.dispatch(editClass(...params, null, revisionID)) }
                                addClass={ (...params) => this.props.dispatch(addClass(...params, null, revisionID)) }
                                classData={ this.props.revision.classes }
                                divisions={ this.props.revision.divisions }
                                isQuote={ false }
                                isRevision={ true }
                                isMasterSite={ true }
                                loader={ this.props.loader }
                                validateBankingDetails={ (...params) => this.props.dispatch(validateBankingDetails(...params)) }
                                bankingDetailsVerifying={ this.props.bankingDetailsVerifying }
                            />
                    }

                    {
                        this.state.selectedSection === 'revision-plan-design' &&
                            <PlanDesign
                                isMasterSite={ true }
                                isQuote={ false }
                                isRevision={ true }
                                setSelectedSection={() => this._selectSection('revision-commissions')}
                                step={ this.props.revision.meta.state }
                                currentAccountMeta={ this.props.currentAccountMeta }
                                classData={ this.props.revision.classes }
                                designs={ this.props.revision.planDesigns }
                                modularBlueprints={ this.props.revision.modularBlueprints }
                                createPlanDesign={ (...params) => this.props.dispatch(createPlanDesign(...params, null, revisionID)) }
                                createPlanDesignFromUpload={ (...params) => this.props.dispatch(createPlanDesignFromUpload(...params, null, revisionID)) }
                                clonePlanDesign={ (...params) => this.props.dispatch(clonePlanDesign(...params, null, revisionID)) }
                                savePlanDesign={ (...params) => this.props.dispatch(savePlanDesign(...params, null, revisionID)) }
                                savePlanDesignBenefitInitData={ (...params) => this.props.dispatch(savePlanDesignBenefitInitData(...params, null, revisionID)) }
                                savePlanDesignField={ (...params) => this.props.dispatch(savePlanDesignField(...params, null, revisionID)) }
                                getPlanDesignRevisions={ (...params) => this.props.dispatch(getPlanDesignRevisions(...params, null, revisionID)) }
                                getSinglePlanDesignRevision={ (...params) => this.props.dispatch(getSinglePlanDesignRevision(...params, null, revisionID)) }
                                revertToRevision={ (...params) => this.props.dispatch(revertToPlanDesignRevision(...params, null, revisionID)) }
                                saveModularBenefitInitData={ (...params) => this.props.dispatch(saveModularBenefitInitData(...params, null, revisionID)) }
                                saveModularField={ (...params) => this.props.dispatch(saveModularField(...params, null, revisionID)) }
                                saveModularBlueprint={ (...params) => this.props.dispatch(saveModularBlueprint(...params, null, revisionID)) }
                                submitPlanDesigns={ (...params) => this.props.dispatch(submitPlanDesigns(...params, null, revisionID)) }
                                submitModuleBlueprint={ (...params) => this.props.dispatch(submitModuleBlueprint(...params, null, revisionID)) }
                                getSpecialityProductMetaConfigs={ () => this.props.dispatch(getSpecialityProductMetaConfigs(this.props.currentAccountMeta.advisorID))}
                                specialityProductMetaConfigs={ this.props.specialityProductMetaConfigs }
                                isPrivateLabelAdvisor={ Boolean(this.props.currentAccountMeta.privateLabelID) }
                            />
                    }

                    {
                        this.state.selectedSection === 'revision-commissions' &&
                            <CommissionsForm
                                currentAccountMeta={ this.props.currentAccountMeta }
                                setSelectedSection={() => this._selectSection('revision-plan-pricing')}
                                submitCommissions={ (...params) => this.props.dispatch(submitCommissions(...params, null, revisionID)) }
                                saveCommissions={ (...params) => this.props.dispatch(saveCommissions(...params, null, revisionID)) }
                                getCommissions={ (...params) => this.props.dispatch(getCommissions(...params, null, revisionID)) }
                                step={ this.props.revision.meta.state }
                                isQuote={ false }
                                isRevision={ true }
                                isMasterSite={ true }
                            />
                    }

                    {
                        this.state.selectedSection === 'revision-plan-pricing' &&
                            <Pricing
                                isMaserSite={ true }
                                setSelectedSection={() => this._selectSection('revision-assign-plans')}
                                accountID={ accountID }
                                classData={ this.props.revision.classes }
                                currentAccountMeta={ this.props.currentAccountMeta }
                                designs={ this.props.revision.planDesigns }
                                commissions={ this.props.revision.commissions }
                                submitPricing={ () => this.props.dispatch(submitPricing(accountID, null, revisionID)) }
                                savePricingInput={ (...params) => this.props.dispatch(savePricingInput(...params, null, revisionID)) }
                                savePricing={ (...params) => this.props.dispatch(savePricing(...params, null, revisionID)) }
                                saveTelusDrugPlanID={ (...params) => this.props.dispatch(saveTelusDrugPlanID(...params, null, revisionID)) }
                                getPricingRevisions={ (...params) => this.props.dispatch(getPricingRevisions(...params, null, revisionID)) }
                                getSinglePricingRevision={ (...params) => this.props.dispatch(getSinglePricingRevision(...params, null, revisionID)) }
                                loading={ this.props.loading }
                                isRevision={ true }
                                step={ this.props.revision.meta.state }
                            />
                    }

                    {
                        this.state.selectedSection === 'revision-assign-plans' &&
                            <AssignPlans
                                whitelabel={{}}
                                classData={ this.props.revision.classes }
                                designs={ this.props.revision.planDesigns }
                                setSelectedSection={() => this._selectSection(null)}
                                currentAccountMeta={ this.props.currentAccountMeta }
                                assignPlans={ (...params) => this.props.dispatch(assignPlans(...params, null, revisionID)) }
                                rejectPricing={ (...params) => this.props.dispatch(rejectPricing(...params, null, revisionID)) }
                                isRevision={ true }
                                isMasterSite={ true }
                                step={ this.props.revision.meta.state }
                            />
                    }
                </Content>

                <Modal
                    open={this.state.showCompleteRevisionsDialog}
                    onClose={this._toggleCompleteRevisions}
                    title="Are you sure?"
                    primaryButton={{
                        label: "Complete Revisions",
                        onClick: this._completeRevisions
                    }}
                    loader={ this.props.loader }
                >
                    <Text medium margin="10px 0 0 0">
                        By clicking the button below, the account revisions will be complete and you will not be able to make further changes.
                    </Text>
                </Modal>

                <Modal
                    open={ this.state.revisionProcessing }
                    title="Revision Processing"
                >
                    <div style={ styles.modalRow }>
                        <img style={ styles.gif } src={ loadingGif }/>
                        <Text small>This may take several minutes. Please do not leave or refresh the page.</Text>
                    </div>
                </Modal>

                <span id="accounts-single" />
            </ContainerControlSite>
        );
    }
}

Revision.propTypes = {
    currentAccountMeta: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentAccountMeta: state.accounts.currentAccount.meta,
    specialityProductMetaConfigs: state.accounts.currentAccount.specialityProductMetaConfigs,
    bankingDetailsVerifying: state.advisors.bankingDetailsVerifying,
    revision: state.accounts.currentAccount.revision
});

export default (connect(mapStateToProps)(Revision));